/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually not for the rise alone. A price increase only grows paper value — it doesn't add points on its own. It's worth the hit when the pick you're swapping to is also projected to outscore your current one; otherwise, the points you lose taking the hit rarely get made back by team value alone.`)
};

const es_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente no, solo por la subida. Un aumento de precio solo hace crecer el valor sobre el papel — no suma puntos por sí solo. Vale la pena el sacrificio cuando el pick al que cambias también tiene previsto superar en puntos al actual; de lo contrario, los puntos que pierdes rara vez se recuperan solo con el valor del equipo.`)
};

const de_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Regel nicht nur für den Preisanstieg allein. Eine Preiserhöhung lässt lediglich den Buchwert wachsen — sie bringt für sich genommen keine Punkte. Der Punkteverlust lohnt sich, wenn der Pick, zu dem du wechselst, ebenfalls voraussichtlich mehr Punkte bringt als dein aktueller; andernfalls gleicht der reine Teamwert die verlorenen Punkte selten wieder aus.`)
};

const nl_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meestal niet alleen voor de stijging. Een prijsstijging vergroot alleen de papieren waarde — die levert op zichzelf geen punten op. Het verlies is de moeite waard als de pick waarnaar je wisselt naar verwachting ook meer punten scoort dan je huidige pick; anders wordt het puntenverlies zelden goedgemaakt door teamwaarde alleen.`)
};

const fr_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Généralement pas pour la seule hausse. Une augmentation de prix ne fait grossir que la valeur de l'équipe — elle n'ajoute pas de points en soi. Le sacrifice vaut le coup quand le choix vers lequel vous basculez est aussi prédit pour marquer plus de points que votre choix actuel ; sinon, les points perdus sont rarement compensés par la seule valeur d'équipe.`)
};

const it_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di solito no, solo per il rialzo in sé. Un aumento di prezzo fa crescere solo il valore sulla carta — non aggiunge punti da solo. Vale la pena sacrificare punti quando la scelta a cui passi è anche prevista segnare più punti di quella attuale; altrimenti, i punti persi con il cambio raramente vengono recuperati dal solo valore della squadra.`)
};

const pt_br2_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geralmente não, só pela alta em si. Um aumento de preço só faz crescer o valor no papel — ele não adiciona pontos por conta própria. Vale a pena perder pontos quando a escolha para a qual você está trocando também é projetada para superar a atual em pontos; caso contrário, os pontos perdidos raramente são recuperados só pelo valor da equipe.`)
};

const pt_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente não, só pela subida em si. Um aumento de preço apenas faz crescer o valor teórico — não soma pontos por si só. Vale a pena perder pontos quando a escolha para a qual troca também tem previsão de superar a atual; caso contrário, os pontos perdidos raramente são recuperados só pelo valor da equipa.`)
};

const ja_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値上がりだけを狙うのであれば、通常は割に合いません。価格の上昇は資産価値を増やすだけで、それ自体がポイントを生むわけではないためです。ペナルティを受ける価値があるのは、乗り換え先のピックが現在のピックより高い得点を挙げると予測される場合です。そうでなければ、ペナルティで失ったポイントをチームの資産価値だけで取り戻すのは難しいでしょう。`)
};

const zh_f1_bb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常不值得——仅仅为了涨价而已。价格上涨只会增加账面身价，本身并不会带来积分。只有当你换入的选择本身预测积分也更高时，承受这次积分损失才值得；否则，单靠车队身价的提升很难弥补换人扣分带来的损失。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq3_a", locale)
	if (locale === "en") return en_f1_bb_faq3_a(inputs)
	if (locale === "es") return es_f1_bb_faq3_a(inputs)
	if (locale === "de") return de_f1_bb_faq3_a(inputs)
	if (locale === "nl") return nl_f1_bb_faq3_a(inputs)
	if (locale === "fr") return fr_f1_bb_faq3_a(inputs)
	if (locale === "it") return it_f1_bb_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq3_a(inputs)
	if (locale === "pt") return pt_f1_bb_faq3_a(inputs)
	if (locale === "ja") return ja_f1_bb_faq3_a(inputs)
	return zh_f1_bb_faq3_a(inputs)
};